import { useEffect, useRef, useState } from 'react';

import { useTheme } from 'styled-components';

import { HotelListFiltersKeyValueViewModel } from '@api/v3';
import Checkbox from '@components/Checkbox';
import {
  CollapsableNameFilterInputWrapper,
  SearchInFiltersInput,
} from '@components/ui/filters/MultiSelectionFilterWithSearchBar/MultiSelectionFilterStyle';
import CustomIcon from '@components/utils/CustomIcon';
import { FilterSearchIcon } from '@assets/icons';
import { PaletteColor } from '@utils/types';

import { DesktopItems, DesktopItem, ShowMoreWrapper } from './styled';

interface Props {
  regions?: HotelListFiltersKeyValueViewModel[];
  onCheck: (checkedKeysValue: number[], e: any) => void;
  isLoading?: boolean;
  isError?: boolean;
  isCity?: boolean;
  selectedRegions?: Array<any>;
}

const GenericRegionFilter = ({
  regions,
  onCheck,
  isError,
  isLoading,
  isCity,
  selectedRegions,
}: Props) => {
  const { palette } = useTheme();

  const [isFullData, setIsFullData] = useState<boolean>(false);
  const wrapperRef = useRef(null);
  const [searchText, setSearchText] = useState('');

  const [filteredData, setFilteredData] = useState<
    HotelListFiltersKeyValueViewModel[] | undefined
  >(regions);

  useEffect(() => {
    if (searchText) {
      const filtered = regions?.filter((item) => {
        return item.value
          ?.toLowerCase()
          .includes(searchText?.toLocaleLowerCase('tr-TR'));
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(regions);
    }
  }, [searchText, regions]);

  const handleOnCheck = (value: boolean, key: number) => {
    let updatedSelectedRegions = selectedRegions ? [...selectedRegions] : [];

    if (value) {
      updatedSelectedRegions.push(key);
    } else {
      updatedSelectedRegions = updatedSelectedRegions.filter(
        (item) => item !== key
      );
    }

    onCheck?.(updatedSelectedRegions, { checked: value });
  };

  const regionsData = isFullData ? filteredData : filteredData?.slice(0, 5);

  const isSelected = (key: number) => selectedRegions?.includes(key);

  return (
    <>
      {isError || isLoading ? null : (
        <CollapsableNameFilterInputWrapper
          className='listing-hotel-name-filter'
          style={{ marginTop: '0' }}
        >
          <SearchInFiltersInput
            placeholder='Ara'
            value={searchText}
            onChange={setSearchText}
            icon={
              <CustomIcon
                icon={FilterSearchIcon}
                fontSize={20}
                style={{ marginRight: '4px' }}
              />
            }
            iconLeft={true}
            useNative
          />
        </CollapsableNameFilterInputWrapper>
      )}
      {!regions?.length || isError || isLoading ? null : (
        <DesktopItems ref={wrapperRef} isShowMore={isFullData}>
          {regionsData?.map((regionItem) => {
            return (
              <DesktopItem key={regionItem.key}>
                <Checkbox
                  key={`${regionItem.key}-${isSelected(regionItem.key)}`}
                  checked={isSelected(regionItem.key)}
                  title={regionItem.value}
                  subTitle={regionItem.count}
                  onChange={(val) => handleOnCheck(val, regionItem.key)}
                  isRegion={isCity}
                  checkOnLabelClick
                  outlineColor={palette.NL800 as PaletteColor}
                  labelStyle={{
                    color: palette.NL800,
                    lineHeight: 'normal',
                    marginLeft: '2px',
                  }}
                  subTitleStyle={{
                    color: palette.NL300,
                    lineHeight: 'normal',
                    opacity: 1,
                  }}
                />
              </DesktopItem>
            );
          })}
        </DesktopItems>
      )}
      {regions &&
      regions?.length > 5 &&
      !isError &&
      !isLoading &&
      !searchText ? (
        <ShowMoreWrapper onClick={() => setIsFullData(!isFullData)}>
          {isFullData ? 'Daha Az Göster' : 'Daha Fazla Göster'}
        </ShowMoreWrapper>
      ) : null}
    </>
  );
};

export default GenericRegionFilter;
